export default __webpack_public_path__ + "static/media/partners-200px.49a81cb1.svg";